"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auth = void 0;
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../schemas");
const schemas_2 = require("../schemas");
const zod_1 = require("zod");
const c = (0, core_1.initContract)();
const authenticatedStatusResponse = zod_1.z.object({
    id: schemas_2.Uuid,
    socketToken: zod_1.z.string(),
    loggedIn: zod_1.z.literal(true),
});
const unauthenticatedStatusResponse = zod_1.z.object({
    loggedIn: zod_1.z.literal(false),
});
const statusResponse = zod_1.z.discriminatedUnion('loggedIn', [
    authenticatedStatusResponse,
    unauthenticatedStatusResponse,
]);
exports.auth = c.router({
    login: {
        method: 'POST',
        path: '/login',
        body: zod_1.z.object({
            email: zod_1.z.string(),
            password: zod_1.z.string(),
        }),
        responses: Object.assign(Object.assign({}, schemas_1.AuthErrorResponse), { 200: authenticatedStatusResponse }),
    },
    logout: {
        method: 'DELETE',
        path: '/logout',
        body: schemas_1.EmptyBody,
        responses: {
            200: unauthenticatedStatusResponse,
        },
    },
    status: {
        method: 'GET',
        path: '/status',
        responses: {
            200: statusResponse,
        },
    },
}, {
    pathPrefix: '/auth',
});
